/* eslint-disable camelcase */

import OrganizationModel from './OrganizationModel';

export default class DeviceModel {
  constructor(data) {
    if (!data) {
      // eslint-disable-next-line no-param-reassign
      data = {};
    }

    this.id = data.id || 0;
    this.serial_number = data.serial_number || '';
    this.nickname = data.nickname || '';

    this.has_data_download = data.has_data_download || false;
    this.organization = new OrganizationModel(data.organization);
    this.site = data.site;
    this.utcOffset = data.utcOffset || -5;

    this.disabled = data.disabled || false;
    this.dataMonitoring = data.dataMonitoring || false;
    this.engineeringUnits = data.engineeringUnits || false;
    this.webOffload = data.webOffload || 'none';
    this.usbOffload = data.usbOffload || 'none';
    this.offloadLocation = data.offloadLocation || 'web';
    this.archiveData = data.archiveData || true;
    this.ownership = data.ownership || 'owned';
    this.downloadInfoOption = data.downloadInfoOption || 'KGB';
    this.fa2100 = data.fa2100 || false;
    this.fa5000 = data.fa5000 || false;
    this.hw6020 = data.hw6020 || false;
    this.hw6023 = data.hw6023 || false;
    this.hw6025 = data.hw6025 || false;
    this.f1000 = data.f1000 || false;
    this.srvivr = data.srvivr || false;
    this.uacvfdr = data.uacvfdr || false;
    this.as4700 = data.as4700 || false;
    this.hwsrvivr = data.hwsrvivr || false;
    this.D51615 = data.D51615 || false;
    this.hfr5 = data.hfr5 || false;
    this.fortressCamera = data.fortressCamera || false;
    this.fortressRecorder = data.fortressRecorder || false;
    this.l3uqar = data.l3uqar || false;
    this.arinc717Transmit = data.arinc717Transmit || false;
    this.arinc717Receive = data.arinc717Receive || false;
    this.arinc429Transmit = data.arinc429Transmit || false;
    this.arinc429Receive = data.arinc429Receive || false;
    this.milStd1553Transmit = data.milStd1553Transmit || false;
    this.milStd1553Receive = data.milStd1553Receive || false;
    this.allowWifi = data.allowWifi || false;
    this.allowEthernet = data.allowEthernet || false;
    this.allowBluetooth = data.allowBluetooth || false;
    this.allowCellular = data.allowCellular || false;
    this.allowDemo = data.allowDemo || false;
    this.allowDemoRemoteView = data.allowDemoRemoteView || false;
    this.lastCheckIn = data.lastCheckIn ? new Date(data.lastCheckIn) : null;
    this.dartVersion = data.dartVersion || 'N/A';
    this.isAllowedDataEncryption = data.isAllowedDataEncryption || false;
    this.latestDartVersion = data.latestDartVersion;
  }

  get status() {
    return this.disabled ? 'Disabled' : 'Enabled';
  }

  get organization_name() {
    return this.organization ? this.organization.name : 'N/A';
  }

  get site_name() {
    return this.site ? this.site.name : 'Primary';
  }

  get site_id() {
    return this.site ? this.site.id : '';
  }

  get organization_id() {
    return this.organization ? this.organization.id : 0;
  }
}
